import type { MoonPayWebSdkInitFn, WindowMoonPayWebSdk } from '@web-sdk';
declare const window: Window & WindowMoonPayWebSdk;

const scriptLoadingStatus = {
  isLoading: false,
  isLoaded: false,
};

export async function loadMoonPay(
  version: string | null = 'v1',
): Promise<MoonPayWebSdkInitFn | undefined> {
  return new Promise((resolve, reject) => {
    const scriptSrc = `https://static.moonpay.com/web-sdk/${version}/moonpay-web-sdk.min.js`;
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    scriptLoadingStatus.isLoading = true;

    const checkLoaded = (count = 0) => {
      if (window.MoonPayWebSdk) {
        scriptLoadingStatus.isLoading = false;
        scriptLoadingStatus.isLoaded = true;
        resolve(window.MoonPayWebSdk.init);
        return;
      }

      // Timeout after 10 seconds
      if (count > 100) {
        scriptLoadingStatus.isLoading = false;
        reject(new Error('Loading MoonPayWebSdk script timed out.'));
        return;
      }

      setTimeout(() => checkLoaded(count + 1), 100);
    };

    if (existingScript) {
      checkLoaded();
    } else {
      const script = document.createElement('script');
      script.async = true;
      script.src = scriptSrc;

      script.addEventListener('load', () => {
        scriptLoadingStatus.isLoading = false;
        scriptLoadingStatus.isLoaded = true;
        resolve(window.MoonPayWebSdk?.init);
      });

      script.addEventListener('error', () => {
        scriptLoadingStatus.isLoading = false;
        scriptLoadingStatus.isLoaded = false;
        reject(new Error('Failed to load MoonPayWebSdk script.'));
      });

      document.body.appendChild(script);
    }
  });
}

export type MoonPayWebSdk = NonNullable<ReturnType<MoonPayWebSdkInitFn>>;
